import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=2a05d99c&"
import script from "./adminLayout.vue?vue&type=script&lang=js&"
export * from "./adminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports